module.exports = __webpack_public_path__ + "static/presenting-5-2963532f4f9335aec2a69add5d80f495.jpg";